const FooterMenu = () => {
    return (
        <div className="footer-menu">
            {/* <div className="container">
                <div className="f-menu">
                    {["Terms of use", "Privacy policy", "Cookies", "Accessibility help", "Advertise with us", "Contact us"].map((item, index) => (
                        <a href="#" key={index}>{item}</a>
                    ))}
                </div>
            </div> */}
        </div>
    );
};

export default FooterMenu;
